module.exports = __webpack_public_path__ + "images/b9589cf3de410fd740728e214e4807a0-apricot.svg";